import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Home.css';
import AboutUs from '../../Components/AboutUs/AboutUs';

const Home = () => {
  return (
    <><div className='main-container'>

      <div>
        <Carousel autoPlay infiniteLoop showThumbs={false}>
          <div>
            <img src="/home/home1.png" alt="Image 1" />
          </div>
          <div>
            <img src="/home/home2.png" alt="Image 2" />
          </div>
          <div>
            <img src="/home/home3.png" alt="Image 3" />
          </div>
          <div>
            <img src="/home/home4.png" alt="Image 4" />
          </div>
          <div>
            <img src="/home/home5.png" alt="Image 5" />
          </div>
        </Carousel>
      </div>
      <div className="home-container">
        <div className="homelink1">Hi there</div>
        <div className="homelink2">Hi here</div>
        <div className="homelink3">Hi wherever</div>
      </div>
      <AboutUs />

    </div>
    </>
  );
}

export { Home };

// {
//   window.innerWidth <= 1024
//     ? <video src="car_bussiness_website/header/video_banner-mobile.mp4" autoPlay loop muted playsInline className="bannerVideo" />
//     : <video src="car_bussiness_website/header/video_banner.mp4" autoPlay loop muted playsInline className="bannerVideo" />
// }